import { storage } from "config/firebase";

export default async function readFile(url: string) {
  const data = await storage.ref().child(url).getDownloadURL()
  return data
}